import * as Sentry from "@sentry/vue";

// オプション ： https://docs.sentry.io/platforms/javascript/configuration/options/#release
export function initializeSentry(Vue, router, role, store = null) {
    Sentry.init({
        Vue: Vue,
        dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
        environment: process.env.NODE_ENV,
        // ログに記録されるすべてのメッセージにスタックトレースを追加する
        attachStacktrace: true,
        // セッショントラッキングを有効にする
        autoSessionTracking: true,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.captureConsoleIntegration(
                {
                    levels: ['error', 'warn'],
                }
            )
        ],
        // 以下は、プランの制限により、無効にしている
        // パフォーマンスデータを送る設定
        tracesSampleRate: 0,
        // ユーザー操作を記録するセッションリプレイの設定
        replaysSessionSampleRate: 0,
        // エラーが発生した時のセッションリプレイの設定
        replaysOnErrorSampleRate: 0,

        // バリデーションエラーを除外する
        beforeSend(event, hint) {
            if (
                hint?.captureContext?.extra?.arguments[0] === 'async-validator:'
            ) {
                return null;
            }
            return event;
        },
        allowUrls: [
            // /public/js/ディレクトリ内のスクリプトのみを対象とする
            /https?:\/\/user\.list\-finder\.jp\/js\//, // prod環境
            /https?:\/\/stg\-user\.list\-finder\.jp\/js\//, // stg環境
            /https?:\/\/user\.list\-finder\.development\/js\//, // local環境
        ],
    });

    if (store === null) {
        return Sentry;
    }

    Sentry.setTag('display', 'online');
    Sentry.setTag('role', role);

    let userPrefix = '';
    if (role === 'admin') {
        userPrefix = 'admin/admin_basic_information/';
    } else if (role === 'user') {
        userPrefix = 'user/user_basic_information/';
        Sentry.setTag('client_id', store.getters[`${userPrefix}getClientId`]);
    }

    if (userPrefix) {
        Sentry.setUser({
            id: store.getters[`${userPrefix}getLoginuserId`],
            username: store.getters[`${userPrefix}getUserName`],
            email: store.getters[`${userPrefix}getEmail`],
        });
    }
}